import { put, call, takeLatest, all } from "redux-saga/effects";
import { sensorGraphConstants } from "../../constants/client";
import { callAPI } from "../commonApiCall";
import apiURLs from "../../config/url-config";
import { sensorGraph, alertActions } from "../../actions";

function* listing(action) {
  try {
    const data = yield call(callAPI, apiURLs.sensorsUrl.getData, action.payload);

    if (data.status === true) {
      yield put(
        sensorGraph.listingSuccess({
          list: data.data && data.data.list,
        })
      );
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {
    console.log(error);
  }
}

function* bulkListing(action) {
  try {
    const { payload } = action;

    const callArray = payload.sensorParameters.map((param) => {
      const { sensorParameters, ...restPayload } = payload;
      return call(callAPI, apiURLs.sensorsUrl.getData, {
        ...restPayload,
        ...param,
      });
    });

    // Use yield all to perform all calls concurrently
    const responses = yield all(callArray);

    // Handle responses if needed
    let result = [];
    responses.forEach((data, index) => {
      if (data.status === true) {
        result.push({ ...payload.sensorParameters[index], list: data.data.list });
      }
    });

    yield put(
      sensorGraph.bulkListingSuccess({
        list: result,
      })
    );
  } catch (error) {
    console.log(error);
  }
}

export function* sensorGraphSaga() {
  yield takeLatest(sensorGraphConstants.LISTING_REQUEST, listing);
  yield takeLatest(sensorGraphConstants.BULK_LISTING_REQUEST, bulkListing);
}
